<ng-template pTemplate="header">
  <h5>Dados do Prestador</h5>
</ng-template>

<div class="flex justify-content-between">
  <table class="detalhe-header mb-4">
    <tr>
      <td>
        <span>006-Registro ANS:</span> {{ operadoraWorkspace?.cd_registro_ans }}
      </td>
      @if (cdGuiaMonitor) {
      <td><span>Cód. lancto:</span> {{ cdGuiaMonitor }}</td>
      }
      <td><span>CNPJ/CPF executante:</span> {{ nrCnpjCpfExec | cpfCnpj }}</td>
    </tr>
    <tr>
      @if (nrCnesExec) {
      <td><span>CNES executante:</span> {{ nrCnesExec }}</td>
      } @if (nrRegistroPlano) {
      <td><span>Nr. registro plano:</span> {{ nrRegistroPlano }}</td>
      }
    </tr>
  </table>

  <div class="flex justify-content-end align-items-center mb-3">
    <button
      class="p-button p-button-outlined p-button-icon-only"
      (click)="dialogPrestadorExportExcel()"
      pTooltip="Exportar Listagem como XLSX"
      tooltipPosition="bottom"
    >
      <i class="pi pi-file-excel"></i>
    </button>
  </div>
</div>

<p-tabs [value]="0">
  <p-tablist>
    <p-tab [value]="0">Dados do CNES</p-tab>
    @if (acessoAbaDadosRPS$ | async; as acessoDadosRps) { @if
    (acessoDadosRps.visivel) {
    <p-tab
      [value]="1"
      [style]="{ opacity: acessoDadosRps.acessivel ? '100%' : '50%' }"
    >
      <span>Dados do RPS</span>
      @if (acessoDadosRps.locked) {
      <i class="pi pi-lock ml-2"></i>
      }
    </p-tab>
    } }
    <p-tab [value]="2">Dados do médico</p-tab>
    <p-tab [value]="3">Atributos de qualidade</p-tab>
    <p-tab [value]="4">Receita Federal</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel [value]="0">
      <div class="grid">
        <div class="col-12">
          <label class="font-semibold">Dados gerais</label>
          <ag-grid-angular
            id="ag-grid-dialog"
            #agGridCnes
            class="ag-theme-balham w-full mt-1"
            [rowData]="rowDadosCnes"
            [gridOptions]="gridOptionsCnes"
          >
          </ag-grid-angular>
        </div>

        @if (nrCnesEncontrado) {
        <div class="col-12 xl:col-7">
          <label class="font-semibold">Serviços especializados</label>
          <ag-grid-angular
            class="ag-theme-balham w-full mt-1"
            [rowData]="rowServicosEspecializadosCnes"
            [gridOptions]="gridOptionsServicosEspecializadosCnes"
            [loading]="carregandoLeitosServicosCnes"
          ></ag-grid-angular>
        </div>

        <div class="col-12 xl:col-5">
          <label class="font-semibold">Leitos</label>
          <ag-grid-angular
            class="ag-theme-balham w-full mt-1"
            [rowData]="rowLeitosCnes"
            [gridOptions]="gridOptionsLeitosCnes"
            [loading]="carregandoLeitosServicosCnes"
          ></ag-grid-angular>
        </div>
        }
      </div>
    </p-tabpanel>
    @if (acessoAbaDadosRPS$ | async; as acessoDadosRps) { @if
    (acessoDadosRps.visivel) {
    <p-tabpanel [value]="1">
      @if (acessoDadosRps.acessivel) {
      <div>
        <ag-grid-angular
          id="ag-grid-dialog"
          #agGridRps
          class="ag-theme-balham w-full"
          [style.height]="'calc(90vh - 250px)'"
          [rowData]="rowDadosRps"
          [gridOptions]="gridOptionsRps"
        >
        </ag-grid-angular>
      </div>
      } @else {
      <div>
        <p>Acessível somente em módulos avançados.</p>
      </div>
      }
    </p-tabpanel>
    } }
    <p-tabpanel [value]="2">
      <div>
        <ag-grid-angular
          id="ag-grid-dialog"
          #agGridMedicos
          class="ag-theme-balham w-full"
          [style.height]="'calc(90vh - 250px)'"
          [rowData]="rowDadosMedicos"
          [gridOptions]="gridOptionsMedicos"
        >
        </ag-grid-angular>
      </div>
    </p-tabpanel>
    <p-tabpanel [value]="3">
      <div>
        <ag-grid-angular
          id="ag-grid-dialog"
          #agGridAtributosQualidade
          class="ag-theme-balham w-full"
          [style.height]="'calc(90vh - 250px)'"
          [rowData]="rowDadosAtributosQualidade"
          [gridOptions]="gridOptionsAtributosQualidade"
        >
        </ag-grid-angular>
      </div>
    </p-tabpanel>
    <p-tabpanel [value]="4">
      <div>
        <ag-grid-angular
          id="ag-grid-dialog"
          #agGridReceitaFederal
          class="ag-theme-balham w-full"
          [style.height]="'calc(90vh - 250px)'"
          [rowData]="rowDadosReceitaFederal"
          [gridOptions]="gridOptionsReceitaFederal"
        >
        </ag-grid-angular>
      </div>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
